import { CoverageWithMeta } from '../Coverage.type';
import { createCoverageMap } from './meta';
import { areAllTriggersSelected } from './select';

export const shouldDisplayCoverage = (
  coverage: CoverageWithMeta, coverages: CoverageWithMeta[],
): boolean => {
  if (coverage.isHidden) return false;

  if (coverage.visibilityTriggerBy?.length) {
    const coveragesMap = createCoverageMap(coverages);

    return areAllTriggersSelected(coverage.visibilityTriggerBy, coveragesMap);
  }

  return true;
};
